export const VALIDATION_ERROR = "VALIDATION_ERROR";
export const DATA_UPDATED = "DATA_UPDATED";
export const ALL_VOUCHER = "ALL_VOUCHER";
export const SET_LOADING = "SET_LOADING";